export enum WizardStepStatus {
  Inactive = 'inactive',
  Active = 'active',
  Completed = 'completed',
}

// // Only used in individ
// export type WizardStepProps = {
//   stepName: WizardStepName;
//   previousStepName?: WizardStepName;
//   stepIndex: number;
//   status: WizardStepStatus;
//   isSelectable: boolean;
//   onNextStep: () => any;
//   onCurrentStep: () => void;
// };

// // Only used in individ
// export type WizardStep = {
//   index: number;
//   name: WizardStepName;
//   status: WizardStepStatus;
//   isSelectable: boolean;
// };
